'use client';

import img_500 from '@/assets/image/500_image.svg';
import Image from 'next/image';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export default function LoaderError() {
    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className="h-screen max-w-6xl mx-auto flex_center flex-col">
            <Image
                width={1000}
                height={1000}
                src={img_500}
                alt="not found"
                className="h-3/4"
            />

            <div className="gap-7">
                <Button onClick={handleRefresh}>رفرش کردن</Button>
                <Badge color="orange">اینترنت خود را چک نمایید !</Badge>
            </div>
        </div>
    );
}
